import { render, staticRenderFns } from "./EmployeeMessages.vue?vue&type=template&id=3a6fecbf&scoped=true"
import script from "./EmployeeMessages.vue?vue&type=script&lang=js"
export * from "./EmployeeMessages.vue?vue&type=script&lang=js"
import style0 from "./EmployeeMessages.vue?vue&type=style&index=0&id=3a6fecbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6fecbf",
  null
  
)

export default component.exports